export const statusOptions = [
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Adjourned', label: 'Adjourned' },
  { value: 'Cancelled', label: 'Cancelled' },
  { value: 'Completed', label: 'Completed' },
];

export const cancellationReasonOptions = [
  { value: 'SOC Withdrawn', label: 'SOC Withdrawn' },
  { value: 'Application Withdrawn', label: 'Application Withdrawn' },
  { value: 'Regulatory Appeal Withdrawn', label: 'Regulatory Appeal Withdrawn' },
  { value: 'Regulatory Appeal Discontinued', label: 'Regulatory Appeal Discontinued' },
  { value: 'Reconsideration Discontinued', label: 'Reconsideration Discontinued' },
  { value: 'Other', label: 'Other' },
];

export const formatOptions = [
  { value: 'Oral', label: 'Oral' },
  { value: 'Written', label: 'Written' },
  { value: 'Electronic', label: 'Electronic' },
];

export const sourceOptions = [
  { value: 'IAR', label: 'IAR' },
  { value: 'App Query', label: 'App Query' },
];

export const typeOptions = [
  { value: 'Application', label: 'Application' },
  { value: 'Regulatory Appeal', label: 'Regulatory Appeal' },
  { value: 'Reconsideration', label: 'Reconsideration' },
  { value: 'Inquiry', label: 'Inquiry' },
];

export const decisionOutcomeOptions = [
  { value: 'Application approved', label: 'Application approved' },
  { value: 'Application denied', label: 'Application denied' },
  { value: 'RA confirmed', label: 'RA confirmed' },
  { value: 'RA suspended', label: 'RA suspended' },
  { value: 'RA revoked', label: 'RA revoked' },
  { value: 'RA varied', label: 'RA varied' },
  { value: 'Reconsideration - decision confirmed', label: 'Reconsideration - decision confirmed' },
  { value: 'Reconsideration - decision varied', label: 'Reconsideration - decision varied' },
  { value: 'Other', label: 'Other' },
];
